import { InMemoryDownload } from "../InMemoryDownload";
import { ReleaseFileList } from "./ReleaseFileList";
import { Release } from "../../models";

interface Props {
  releaseFiles: ReleaseFileList;
  release: Release;
}

export function Tr2FileList({ releaseFiles, release }: Props) {
  const appAndBlName = `token_mcuboot_and_app.${release.version}.bin`;

  return (
    <>
      <td>
        <InMemoryDownload
          displayName="OTA Updatable App"
          fileName={release.version}
          content={releaseFiles.releaseAppOnly?.data}
        />
        {releaseFiles.releaseAppAndBootloaderDevKeys && (
          <>
            <br />
            <InMemoryDownload
              displayName="App + Bootloader"
              fileName={appAndBlName}
              content={releaseFiles.releaseAppAndBootloaderDevKeys?.data}
            />
          </>
        )}
        {releaseFiles.releaseAppOnlyElf && (
          <>
            <br />
            <InMemoryDownload
              displayName="OTA Updatable App (Elf)"
              fileName={`${release.version}.elf`}
              content={releaseFiles.releaseAppOnlyElf?.data}
            />
          </>
        )}
        {releaseFiles.releaseFimeTest && (
          <>
            <br />
            <InMemoryDownload
              displayName="fime_test.bin"
              fileName="fime_test.bin"
              content={releaseFiles.releaseFimeTest?.data}
            />
          </>
        )}
        {releaseFiles.releaseMfg && (
          <>
            <br />
            <InMemoryDownload
              displayName="Manufacturing"
              fileName="mfg.bin"
              content={releaseFiles.releaseMfg?.data}
            />
          </>
        )}
        {releaseFiles.releaseMfgElf && (
          <>
            <br />
            <InMemoryDownload
              displayName="Manufacturing (Elf)"
              fileName="mfg.elf"
              content={releaseFiles.releaseMfgElf?.data}
            />
          </>
        )}
        {releaseFiles.bootloaderRelease && (
          <>
            <br />
            <InMemoryDownload
              displayName="Bootloader"
              fileName="bootloader.bin"
              content={releaseFiles.bootloaderRelease?.data}
            />
          </>
        )}
        {release.releaseMeta && (
          <>
            <br />
            <InMemoryDownload
              displayName="Metadata"
              fileName="metadata.json"
              content={window.btoa(release.releaseMeta)}
            />
          </>
        )}
      </td>
      <td>
        {releaseFiles.debugAppOnly && (
          <InMemoryDownload
            displayName="OTA Updatable App"
            fileName={release.vcsCommit}
            content={releaseFiles.debugAppOnly?.data}
          />
        )}
        {releaseFiles.debugAppAndBootloader && (
          <>
            <br />
            <InMemoryDownload
              displayName="App + Bootloader"
              fileName={appAndBlName}
              content={releaseFiles.debugAppAndBootloader?.data}
            />
          </>
        )}
        {releaseFiles.debugFimeTest && (
          <>
            <br />
            <InMemoryDownload
              displayName="fime_test.bin"
              fileName="fime_test.bin"
              content={releaseFiles.debugFimeTest?.data}
            />
          </>
        )}
        {release.debugMeta && (
          <>
            <br />
            <InMemoryDownload
              displayName="Metadata"
              fileName="metadata.json"
              content={window.btoa(release.debugMeta)}
            />
          </>
        )}
      </td>
      <td>
        {releaseFiles.translationsFile && (
          <InMemoryDownload
            displayName="til.json"
            fileName="til.json"
            content={releaseFiles.translationsFile?.data}
          />
        )}
        {releaseFiles.translationsFile && releaseFiles.locationsFile && <br />}
        {releaseFiles.locationsFile && (
          <InMemoryDownload
            displayName="li.json"
            fileName="li.json"
            content={releaseFiles.locationsFile?.data}
          />
        )}
      </td>
    </>
  );
}
